<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="col-md-12">
          <ol class="breadcrumb breadcrumb-card-header pull-left">
            <li class="breadcrumb-item">
              <a href="javascript:void(0);" @click="backParent"> Payment Method</a>
            </li>
            <li class="breadcrumb-item active">
              <span v-if="paymentMethod.id === null">New</span>
              <span v-else>
                {{ paymentMethod.name }}
              </span>
            </li>
          </ol>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-9">
            <div class="form-group row">
              <label for="name" class="col-sm-3 col-form-label text-left">Name</label>
              <div class="col-sm-9">
                <input type="text" v-model="paymentMethod.name" class="form-control"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <button type="button" @click="backParent" class="btn btn-sm btn-danger pull-left"><i class="fa fa-reply" aria-hidden="true"></i> Back</button>
        <button type="button" @click="updatePaymentMethod" class="btn btn-sm btn-primary pull-right" v-show="paymentMethod.id !== null"><i class="fa fa-save" aria-hidden="true"></i> Update</button>
        <button type="button" @click="createPaymentMethod" class="btn btn-sm btn-primary pull-right" v-show="paymentMethod.id == null"><i class="fa fa-check" aria-hidden="true"></i> Save</button>
      </div>
    </div>
    <!-- <pre>
      {{ paymentMethod }}
    </pre> -->
  </div>
</template>

<script>
import axios from 'axios'
import { paymentMethodUrl, getHeader } from '../../config'

export default {
  name: 'PaymentMethodForm',
  props: ['paymentMethod'],
  methods: {
    backParent: function () {
      this.$emit('backClicked')
    },
    updatePaymentMethod () {
      axios.put(paymentMethodUrl + '/' + this.paymentMethod.id, this.paymentMethod, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal('Payment Method', response.data.message, 'success')
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error!!', '', 'error')
        })
    },
    createPaymentMethod () {
      axios.post(paymentMethodUrl, this.paymentMethod, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$emit('backClicked')
        })
        .catch(response => {
          console.log(response)
          this.$swal('Error!!', response.data, 'error')
        })
    }
  }
}
</script>
